<template>
  <div class="border-top">
    <SOFilterTitle :title="title" :id="id"/>
    <div class="p-l-24 p-r-24 p-d-24" :id="id">
      <SOInputCheckbox
        :checkboxes="dataKonsumen"
        :checked="filterItem.dataKonsumen"
        @selected="selected"
      />
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import SOFilterTitle from "@/so-components/global/filter/base/SOFilterTitle";
import SOInputCheckbox from "@/so-components/global/input/SOInputCheckbox";

export default {
  name: "SOFilterDataKonsumen",
  components: {
    SOFilterTitle,
    SOInputCheckbox,
  },
  props: {
    id: String,
    title: {
      type: String,
      default: "Data Konsumen",
    },
  },
  computed: {
    ...mapGetters("filterGlobalModule", {
      filterItem: "getFilterItem"
    })
  },
  data() {
    return {
      dataKonsumen: {
        name: "data-konsumen",
        data: [
          {
            id: "fdtKons-1",
            value: "1",
            title: "Konsumen terdaftar",
            checked: false,
            titleBold: false,
          },
          {
            id: "fdtKons-2",
            value: "2",
            title: "Konsumen tidak terdaftar",
            checked: false,
            titleBold: false,
          },
        ]
      },
    }
  },
  methods: {
    selected(val) {
      let temp = this.filterItem
      temp.dataKonsumen = val
      this.$store.commit("filterGlobalModule/setFilterItem", temp)
    }
  }
}
</script>